import React, { useState, useEffect } from 'react'
import Intro from './scenes/Intro'
import StartScreen from './scenes/StartScreen'
import MenuDida from './scenes/MenuDida'
import MenuMusic from './scenes/MenuMusic'
import Module1 from './scenes/Module1';
import Module2 from './scenes/Module2';
import Module3a from './scenes/Module3a';
import Module3b from './scenes/Module3b';
import Module3c from './scenes/Module3c';
import Module3d from './scenes/Module3d';
import Module3e from './scenes/Module3e';
import Module3f from './scenes/Module3f';
import Module4a1 from './scenes/Module4a1';
import Module4b2 from './scenes/Module4b2';
import Module4c3 from './scenes/Module4c3';
import Module5a1 from './scenes/Module5a1';
import Module5b2 from './scenes/Module5b2';
import Module5c3 from './scenes/Module5c3';
import Module5d4 from './scenes/Module5d4';
import Module5e5 from './scenes/Module5e5';
import Module5f6 from './scenes/Module5f6';
import Module6a from './scenes/Module6a';
import Module6b from './scenes/Module6b';
import Module6c from './scenes/Module6c';
import Toots from './scenes/Toots';
import Nav from './utils/Nav';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Module2v from './scenes/Module2v'
import Module6av from './scenes/Module6av'
import StartScreenWithoutIntro from './scenes/StartScreenWithoutIntro'

export default function Player() {

  const [isIntroFinished, setIsIntroFinished] = useState(false);
  const [firstTime, setFirstTime] = useState(true);

  let audio = []

  const [langue, setLangue] = useState('en');

  return (
    <>
      <div
        className='background'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '660px',
          height: '500px',
          overflow: 'hidden',
        }}
      >
        <BrowserRouter>
          <div>
            <Nav audio={audio} langue={langue} />
            <Routes>
              <Route exact path='' element={
                isIntroFinished ?
                  <Navigate to={process.env.PUBLIC_URL + "/menu/"} replace /> :
                  <Intro
                    callback={() => {
                      setIsIntroFinished(true);
                    }}
                  />
              } />
              <Route path={process.env.PUBLIC_URL + '/menu'} element={<StartScreen langue={langue} setLangue={setLangue} firstTime={firstTime} setFirstTime={setFirstTime} />} />
              <Route path={process.env.PUBLIC_URL + '/menu_sans_intro'} element={<StartScreenWithoutIntro langue={langue} setLangue={setLangue} firstTime={firstTime} setFirstTime={setFirstTime} />} />
              <Route path={process.env.PUBLIC_URL + '/menudida/'} element={<MenuDida langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/menumusic/'} element={<MenuMusic langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/intro/'} element={<Module1 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/captation/'} element={<Module2 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/2-captation-video/'} element={<Module2v langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/'} element={<Module3a langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/2-markov/'} element={<Module3b langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/3-uzeste/'} element={<Module3c langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/4-donnalee/'} element={<Module3d langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/5-walking/'} element={<Module3e langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/imitation/6-motives/'} element={<Module3f langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-a/'} element={<Module4a1 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-a/2-patch/'} element={<Module4b2 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-a/3-arpeggios/'} element={<Module4c3 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/'} element={<Module5a1 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/2-hothouse/'} element={<Module5b2 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/3-rewrite/'} element={<Module5c3 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/4-godel/'} element={<Module5d4 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/5-substitute/'} element={<Module5e5 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/transfo-b/6-goodbye/'} element={<Module5f6 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/control/'} element={<Module6a langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/control/1-video/'} element={<Module6av langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/control/2-lubatyscaphe/'} element={<Module6b langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/control/3-memory/'} element={<Module6c langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/toots/'} element={<Toots langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/toots/:page/'} element={<Toots langue={langue} audio={audio} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            
            
          </div>
        </BrowserRouter>
      </div>
    </>
  )
}
